import { Injectable } from '@angular/core';

@Injectable()
export class CampaignPagingService {

  public setFilter(value: number) {
    localStorage.setItem('campaignsFilter', value.toString());
  }

  public getFilter(): number {
      let value = parseInt(localStorage.getItem('campaignsFilter'), 10);
      if (isNaN(value)) {
        value = 1;
      }

      return value;
  }

  public setSortFilter(value: number) {
    localStorage.setItem('campaignsSortFilter', value.toString());
  }

  public getSortFilter(): number {
      let value = parseInt(localStorage.getItem('campaignsSortFilter'), 10);
      if (isNaN(value)) {
          value = 6;
      }

      return value;
  }

}
